import { render, staticRenderFns } from "./TopPerformers.vue?vue&type=template&id=5b80b87d&scoped=true&"
import script from "./TopPerformers.vue?vue&type=script&lang=js&"
export * from "./TopPerformers.vue?vue&type=script&lang=js&"
import style0 from "./TopPerformers.vue?vue&type=style&index=0&id=5b80b87d&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5b80b87d",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VFlex } from 'vuetify/lib/components/VGrid';
installComponents(component, {VFlex})
